import {styled} from "@mui/material/styles"
import Typography from "@mui/material/Typography"
import {FALLBACK_FONT_FAMILY, breakpoints} from "@next/ux-fabric"
import {EnrichedMaxItemsConfig} from "../../../../models/search"
import {IMAGE_GAP} from "../../../../config/constants"

export const List = styled("li")`
    && {
        flex-grow: 0;
        padding: 1rem 0 0.75rem;

        &:hover {
            text-decoration: underline;
        }

        a {
            color: ${({theme}) => theme.uxfabric.text.primary};
            text-decoration: none;
            margin: 0.125rem 0;
            display: inline-block;
            margin: 0;
            height: 0px;
            position: relative;
            background: ${({theme}) => theme.uxfabric.components.menu.searchMenu.enriched.backgroundColor};
            letter-spacing: 0.12px;
            line-height: 1.5;
            height: auto;
            width: 9.375rem;

            @media (min-width: ${breakpoints.values.md}px) {
                padding-top: none;
                width: 9.375rem;
                height: 12.5rem;
            }
            img {
                height: auto;
                width: 9.375rem;
            }

            &:hover {
                text-decoration: underline;
                padding-left: 0;
            }

            h5 {
                align-self: flex-start;
                margin: 0;
                font-family: ${({theme}) =>
                    `${theme.uxfabric.global.h5.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
            }
            @media (max-width: ${breakpoints.values.md - 1}px) {
                max-width: 6.25rem;
                img {
                    max-width: 6.25rem;
                }
            }
        }
    }
`

export const Title = styled(Typography)`
    && {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 100%;
        margin: 0;
        font-size: ${({theme}) => theme.uxfabric.global.body2.fontSize};
        text-transform: ${({theme}) => theme.uxfabric.global.body2.textTransform} !important;
        font-family: ${({theme}) => theme.uxfabric.global.body2.fontFamily}, ${FALLBACK_FONT_FAMILY} !important;
        letter-spacing: ${({theme}) => theme.uxfabric.global.body2.letterSpacing}px !important;
    }
`
export const ProductDetailsContainer = styled("div")`
    text-align: left;
    margin-top: 0.5rem;
`

type UlProps = {
    maxitems: EnrichedMaxItemsConfig
    xxlBreakpointEnabled: boolean
    maxItemscount: number
    productLength: number
}

export const ListContainer = styled("ul")<UlProps>`
    margin: 0;
    padding: 0;
    list-style: none;

    display: flex;
    justify-content: normal;
    width: 100%;
    overflow-x: scroll;
    &::-webkit-scrollbar {
        display: none;
    }

    -ms-overflow-style: none;
    scrollbar-width: none;
    gap: ${IMAGE_GAP}px;

    @media (max-width: ${breakpoints.values.md - 1}px) {
        gap: 1rem;
    }

    @media (min-width: ${breakpoints.values.md}px) {
        li:nth-child(n + ${props => props.maxItemscount + 1}) {
            display: none;
        }
        li:nth-child(-n + ${props => props.maxItemscount}) {
            margin-right: 0;
        }
    }
`

export const SearchTitle = styled(Typography)`
    text-transform: ${({theme}) => theme.uxfabric.global.subtitle2.textTransform};
    font-family: ${({theme}) => theme.uxfabric.global.subtitle2.fontFamily}, ${FALLBACK_FONT_FAMILY} !important;
    letter-spacing: ${({theme}) => theme.uxfabric.global.subtitle2.letterSpacing}px !important;
    font-size: ${({theme}) => theme.uxfabric.global.subtitle2.fontSize} !important;
    font-weight: ${({theme}) => theme.uxfabric.global.subtitle2.fontWeight} !important;
    line-height: ${({theme}) => theme.uxfabric.global.subtitle2.lineHeight} !important;
`

export const ButtonContainer = styled("div")`
    letter-spacing: ${({theme}) => theme.uxfabric.component.buttonMedium.letterSpacing}px;
    font-family: ${({theme}) => theme.uxfabric.component.buttonMedium.fontFamily}, ${FALLBACK_FONT_FAMILY} !important;
    font-size: ${({theme}) => theme.uxfabric.component.buttonMedium.fontSize};
    font-weight: ${({theme}) => theme.uxfabric.component.buttonMedium.fontWeight};
    line-height: ${({theme}) => theme.uxfabric.component.buttonMedium.lineHeight};
    text-transform: ${({theme}) => theme.uxfabric.component.buttonMedium.textTransform};
    height: 2.75rem;
    width: auto;
    margin-right: 1rem;

    @media (min-width: ${breakpoints.values.md}px) {
        height: 2.25rem;
        margin-right: 0;
    }

    && span {
        line-height: 0;
        margin: 0 0 0 0.5rem;
        padding: 0;
    }
`
export const ButtonContainerWrapper = styled("div")`
    float: right;
    padding-right: 1.5rem;
    @media (max-width: ${breakpoints.values.lg}px) {
        padding-right: 1rem;
    }
`

type SvgProps = {
    isRTL: boolean
}

export const StyledSvg = styled("svg")<SvgProps>`
    ${props => (props.isRTL ? "transform: rotate(180deg)" : "")};
`
export const Price = styled("h5")`
    letter-spacing: ${({theme}) => theme.uxfabric.global.body3.letterSpacing}px !important;
    font-family: ${({theme}) => theme.uxfabric.global.body3.fontFamily}, ${FALLBACK_FONT_FAMILY} !important;
    font-size: ${({theme}) => theme.uxfabric.global.body3.fontSize} !important;
    font-weight: ${({theme}) => theme.uxfabric.global.body3.fontWeight} !important;
    line-height: ${({theme}) => theme.uxfabric.global.body3.lineHeight} !important;
`
